import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableAdBuilder = Loadable({
  loader: function loader() {
    return import('../AdBuilder.jsx');
  },
  loading: ComponentLoading
});
export default LoadableAdBuilder;